





































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IInvoice } from "@/models/invoices";
import RequestPromises from "@/mixins/requestPromises";

@Component({
  components: {
    "invoice-provider": () =>
      import("@/components/app/global/invoices/invoiceProvider.vue"),
    "invoice-status-msg": () =>
      import("@/components/app/global/invoices/invoiceStatusMsg.vue"),
    "invoice-pending-payment-msg": () =>
      import("@/components/app/global/invoices/invoicePendingPaymentMsg.vue"),
    "invoice-duplicate-msg": () =>
      import("@/components/app/global/invoices/invoiceDuplicateMsg.vue"),
    "invoice-duplicated-msg": () =>
      import("@/components/app/global/invoices/invoiceDuplicatedMsg.vue"),
    "invoice-details": () =>
      import("@/components/app/global/invoices/invoiceDetails.vue"),
    "payments-table": () =>
      import("@/components/app/global/invoices/paymentsTable.vue")
  }
})
export default class InvoiceModal extends Mixins(RequestPromises) {
  // Props
  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];

  // Life-cycle methods
  public beforeDestroy() {
    if (this.$route.name === "adminInvoicePreview") {
      const path = this.$route.fullPath.replace(this.invoiceId, "");
      this.$router.replace(path).catch(err => err);
    }
  }
}
